if (!customElements.get('marquee-slider')) {
  class MarqueeSlider extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.columnsMobile = this.dataset.columnsMobile || 2;
      this.columnsDesktop = this.dataset.columnsDesktop || 5;

      this.swiperContainer = this.querySelector('.swiper');

      if (this.swiperContainer && Swiper) {
        this.swiper = new Swiper(this.swiperContainer, {
          slidesPerView: this.columnsMobile,
          loop: true,
          speed: 3000,
          autoplay: {
            delay: 0
          },
          freeMode: {
            enabled: true,
            sticky: false,
          },
          breakpoints: {
            990: {
              slidesPerView: this.columnsDesktop,
              loop: true
            }
          }
        });
      }
    }

    disconnectedCallback() {
    }
  }

  customElements.define('marquee-slider', MarqueeSlider);
}